import React, { useState } from "react"
import {
    Box,
    Modal,
    Typography,
    Button,
    Checkbox,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    CircularProgress,
    IconButton,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

export default function AddWorkersModal({ open, onClose, workers, selectedWorkers, onWorkersChange, onAdd, loading }) {
    const handleToggle = (worker) => {
        const isSelected = selectedWorkers.some((w) => w.id === worker.id)
        if (isSelected) {
            onWorkersChange(selectedWorkers.filter((w) => w.id !== worker.id))
        } else {
            onWorkersChange([...selectedWorkers, worker])
        }
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #E4E7EC",
                    width: "500px",
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "0px 8px 24px rgba(0,0,0,0.1)",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: 3,
                        borderBottom: "1px solid #E4E7EC",
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: "20px",
                            color: "#101828",
                        }}
                    >
                        Add Workers to Attendance Sheet
                    </Typography>
                    <IconButton onClick={onClose} sx={{ "&:hover": { backgroundColor: "#f0f0f0" } }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Workers List */}
                <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
                    {loading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                            <CircularProgress />
                        </Box>
                    ) : workers.length === 0 ? (
                        <Box sx={{ py: 4, textAlign: "center" }}>
                            <Typography sx={{ color: "#667085", fontSize: "14px" }}>
                                No workers available to add
                            </Typography>
                        </Box>
                    ) : (
                        <List>
                            {workers.map((worker) => {
                                const isSelected = selectedWorkers.some((w) => w.id === worker.id)
                                return (
                                    <ListItem key={worker.id} disablePadding>
                                        <ListItemButton onClick={() => handleToggle(worker)}>
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={isSelected}
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={`${worker.firstName} ${worker.lastName}`}
                                                secondary={`${worker.speciality} • ${worker.nationality}`}
                                                primaryTypographyProps={{
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    color: "#101828",
                                                }}
                                                secondaryTypographyProps={{
                                                    fontSize: "12px",
                                                    color: "#667085",
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                )
                            })}
                        </List>
                    )}
                </Box>

                {/* Footer */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1.5,
                        p: 3,
                        borderTop: "1px solid #E4E7EC",
                    }}
                >
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        disabled={loading}
                        sx={{
                            textTransform: "none",
                            borderColor: "#E4E7EC",
                            color: "#344054",
                            "&:hover": { borderColor: "#D0D5DD" },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onAdd}
                        disabled={loading || selectedWorkers.length === 0}
                        sx={{
                            backgroundColor: "#4D6BF6",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": { backgroundColor: "#3D5BD6" },
                            "&:disabled": { backgroundColor: "#E4E7EC", color: "#667085" },
                        }}
                    >
                        {loading ? "Adding..." : `Add ${selectedWorkers.length} Worker(s)`}
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}

